// Description: This component is responsible for the recovery of the user's password. It has three steps:
// Updated: 04/08/2025
// Author: Vitor Jesus


// React
import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

// Material UI Components
import { Box, Grid, useMediaQuery } from '@mui/material';

// Components and Functions for the project
import { ChangePassword } from '../../api/aws/Auth/ChangePassword';
import Erro from '../Error/index'
import FormRecovery from './FormRecovery';
import FormChangePassword from './FormChangePassword';
import Logo from '../../assets/ilustrations/Logo';
import './styles.css';
import { TryRecovery } from '../../api/aws/Auth/TryRecovery';
import MobileLoginRecovery from './MobileLoginRecovery';
import MobileChangePassword from './MobileChangePassword';
import { notify } from '../../utils/utils';

// Render The Page
const LoginRecoveryPage = () => {

    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState('');
    const [codeConfirm, setCodeConfirm] = useState('');
    const [showForm, setShowForm] = useState(false);
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [searchParams] = useSearchParams();
    const code = searchParams.get('code');
    const [tokenType, setTokenType] = useState('initial');
    const isSmallScreen = useMediaQuery("(max-width:600px)");

    const Navigate = useNavigate();

    const handleSubmit = async (event) => {

        event.preventDefault();

        if (!username) {
            setMessage('Por favor, preencha o campo de email.');
            return;
        }

        setLoading(true);

        let recoveryInfo = { 'user': username }

        try {

            const response = await TryRecovery(recoveryInfo);

            if (response.status === 'success') {
                setMessage('');
                console.log('Resposta da API:', response);
                notify("Success", "Um e-mail foi enviado para você, clique no botão e finalize o processo de recuperação de senha", true)
                Navigate("/login")
            } else if (response.status === 404) {
                setMessage('Esse email ou usuário é inválido.');
            }

            setLoading(false);

        } catch (error) {
            console.error('Erro ao buscar dados da API:', error);
            throw error;
        }
    };

    const verifyLink1IsValid = async () => {

        let url2Info = { 'token': code }

        try {

            const res = await fetch(`${process.env.REACT_APP_BACKEND_AWS_URL}/auth/verify-token`, {
                method: "POST",
                body: JSON.stringify(url2Info)
            });

            const response = await res.json();

            if (response.status === 'success') {
                setTokenType('url2');
                setShowForm(true);
            } else {
                setShowForm(false);
                setTokenType('error')
                notify("Error", "Erro ao verificar o token", true);
                Navigate("/login");
            }

        } catch (error) {
            console.error('Erro ao buscar dados da API:', error);
            throw error;
        }
        finally {
            setLoading(false);
        }
    };

    const handleSubmitChangePassword = async (event) => {

        event.preventDefault();

        if (!newPassword || !confirmPassword) {
            setMessage('Por favor, preencha todos os campos.');
            return;

        }

        if (newPassword !== confirmPassword) {
            setMessage('As senhas não coincidem.');
            return;
        }

        setLoading(true);

        let changePasswordInfo = { 'password': newPassword, 'token': code, 'confirmPassword': confirmPassword }

        try {

            const response = await ChangePassword(changePasswordInfo);

            console.log('Resposta da API3:', response);

            if (response.status === 'success') {
                Navigate('/', { state: { message: 'Senha alterada com sucesso.' } });
            } else {
                setMessage('Ocorreu um erro ao alterar a senha.');
            }

        } catch (error) {
            console.error('Erro ao buscar dados da API:', error);
            throw error;
        }
        finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (code !== undefined && code !== null) {
            verifyLink1IsValid();
        };

        console.log("Parâmetro da url", code);

    }, [code]);

    return (

        <>

            {tokenType === 'initial' ? (
                <>
                    {
                        isSmallScreen ? (
                            <MobileLoginRecovery username={username} setUsername={setUsername} password={password} setPassword={setPassword} loading={loading} setLoading={setLoading} message={message} setMessage={setMessage} codeConfirm={codeConfirm} setCodeConfirm={setCodeConfirm} handleSubmit={handleSubmit} />
                        ) : (
                            <>
                                <div style={{
                                    position: 'absolute',
                                    top: '20px',
                                    left: '20px',
                                    padding: '10px',
                                }}>
                                    <Logo />
                                </div>
                                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', background: 'linear-gradient(135deg, #ffffff 0%, #EDE8FF 100%)', }}>
                                    <Grid container spacing={2} sx={{ display: 'flex', alignItems: 'stretch', justifyContent: 'center', maxWidth: { xl: 1200, lg: 1100 }, height: { xl: 460.200, lg: 422.0034 }, width: '100%', margin: 'auto', padding: '0px' }}>
                                        <Grid item xs={12} md={4.5} sx={{ display: 'flex', justifyContent: 'left', alignItems: { xl: 'left', lg: 'end' }, maxHeight: '100%' }}>
                                            <FormRecovery username={username} setUsername={setUsername} password={password} setPassword={setPassword} loading={loading} setLoading={setLoading} message={message} setMessage={setMessage} codeConfirm={codeConfirm} setCodeConfirm={setCodeConfirm} handleSubmit={handleSubmit} />
                                        </Grid>
                                    </Grid>
                                </Box>
                            </>
                        )
                    }
                </>
            ) : tokenType === 'url2' ? (
                <>
                    {
                        isSmallScreen ? (
                            <MobileChangePassword loading={loading} setLoading={setLoading} message={message} setMessage={setMessage} codeConfirm={codeConfirm} setCodeConfirm={setCodeConfirm} handleSubmitChangePassword={handleSubmitChangePassword} newPassword={newPassword} setNewPassword={setNewPassword} confirmPassword={confirmPassword} setConfirmPassword={setConfirmPassword} />
                        ) : (
                            <>
                                <div style={{
                                    position: 'absolute',
                                    top: '20px',
                                    left: '20px',
                                    padding: '10px',
                                }}>
                                    <Logo />
                                </div>
                                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', background: 'linear-gradient(135deg, #ffffff 0%, #EDE8FF 100%)', }}>
                                    <Grid container spacing={2} sx={{ display: 'flex', alignItems: 'stretch', justifyContent: 'center', maxWidth: { xl: 1200, lg: 1100 }, height: { xl: 460.200, lg: 422.0034 }, width: '100%', margin: 'auto', padding: '0px' }}>
                                        <Grid item xs={12} md={4.5} sx={{ display: 'flex', justifyContent: 'left', alignItems: { xl: 'left', lg: 'end' }, maxHeight: '100%' }}>
                                            <FormChangePassword loading={loading} setLoading={setLoading} message={message} setMessage={setMessage} codeConfirm={codeConfirm} setCodeConfirm={setCodeConfirm} handleSubmitChangePassword={handleSubmitChangePassword} newPassword={newPassword} setNewPassword={setNewPassword} confirmPassword={confirmPassword} setConfirmPassword={setConfirmPassword} />
                                        </Grid>
                                    </Grid>
                                </Box>
                            </>
                        )
                    }
                </>

            ) : tokenType === 'error' ? (
                <Erro />
            ) : null}
        </>
    )
};

export default LoginRecoveryPage;